"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRegisterBody = exports.MinimumPasswordLength = void 0;
const validation_1 = require("@fmtk/validation");
exports.MinimumPasswordLength = 8;
exports.validateRegisterBody = (0, validation_1.properties)({
    accessCode: (0, validation_1.text)(),
    email: (0, validation_1.text)(),
    familyName: (0, validation_1.text)(),
    givenName: (0, validation_1.text)(),
    password: (0, validation_1.text)(undefined, exports.MinimumPasswordLength),
});
//# sourceMappingURL=RegisterBody.js.map